'use strict';

module.exports = {
    googleIntegrations: [{
        name: 'Gmail',
        desc: 'Fill out and sign documents without ever leaving Gmail. It takes less than 30 seconds.',
        href: '/gmail', // Integration link
        src: 'gmail' // Image src
    }, {
        name: 'Google Docs',
        desc: 'Draft, edit and send your document for signature without ever leaving Google Docs.',
        href: '/google-docs-add-on',
        src: 'googledocs'
    }, {
        name: 'Google Drive',
        desc: 'Connect your account with HelloSign to sign documents, request signatures, and set-up templates right in Drive.',
        href: '/googledrive',
        src: 'googledrive'
    }, {
        name: 'Google Apps For Work',
        desc: 'Deploy eSignatures to your entire company in minutes. All of your users can log in to their HelloSign account with Single Sign On (SSO).',
        href: 'https://apps.google.com/marketplace/app/cmblnlmegcfpannmkinlnfpjplgfmbcb',
        src: 'googleapps'
    }],
    businessApplications: [{
        name: 'Box',
        desc: 'Sign Box documents from your HelloSign account and quickly send documents for signature from Box.',
        href: '/box',
        src: 'box'
    }, {
        name: 'Dropbox',
        desc: 'Import documents from Dropbox and save signed copies in Dropbox.',
        href: '/dropbox',
        src: 'dropbox'
    }, {
        name: 'Evernote',
        desc: 'Access notes in HelloSign and store signed documents in your Evernote account.',
        href: '/evernote',
        src: 'evernote'
    }, {
        name: 'HubSpot CRM',
        desc: 'Integrate HelloSign with HubSpot CRM to request signatures, track lifecycle status, and manage sales contracts out for signature.',
        href: '/hubspot-crm',
        src: 'hubspot'
    }, {
        name: 'Microsoft OneDrive',
        desc: 'Store copies of documents in your OneDrive account and easily send files for signature.',
        href: '/onedrive',
        src: 'onedrive'
    }, {
        name: 'Oracle',
        desc: 'Request signatures for your contracts, agreements, and waivers directly from Oracle Documents Cloud.',
        href: '/oracle',
        src: 'oracle'
    }, {
        name: 'Salesforce',
        desc: 'Send contracts for signature directly from Salesforce. Get status updates in Salesforce, auto-fill contract details and more.',
        href: '/salesforce',
        src: 'salesforce'
    }, {
        name: 'Slack',
        desc: 'Keep your teams and channels in the know on the status of your signed documents.',
        href: '/slack',
        src: 'slack'
    }],
    eventWaivers: [{
        name: 'Eventbrite',
        desc: 'Automagically send event waivers, photo releases, contracts, and more to your attendees directly from Eventbrite.',
        href: 'https://www.eventbrite.com/spectrum/hellosign',
        src: 'eventbrite'
    }],
    insuranceTools: [{
        name: 'QQ Catalyst',
        desc: 'Sync QQ Catalyst documents back to QQ Catalyst once they are signed by all parties.',
        href: '/home/myAccount#integrations',
        src: 'qqcatalyst'
    }],
    thirdParty: [{
        name: 'Zapier',
        desc: 'Integrate with hundreds of services by connecting your HelloSign account to Zapier.',
        href: 'https://zapier.com/zapbook/hellosign',
        src: 'zapier'
    }]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/integrations.js
 ** module id = 1597
 ** module chunks = 0
 **/